var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.571 16.804L24.572 16.804C24.572 16.804 25.2683 18.2674 26.922 19.3463C28.5757 20.4251 29.6311 20.5427 29.6311 20.5427L29.6311 21.3225C29.6311 21.3225 28.2929 21.472 26.6935 22.7645C25.0942 24.057 24.572 25.0398 24.572 25.0398L23.571 25.0398C23.571 25.0398 24.6917 22.5616 25.834 21.6002L12.5933 21.6002L12.5933 20.329L25.8231 20.329C25.8231 20.329 24.1694 18.6306 23.5601 16.8146L23.571 16.804Z",
    fill: "inherit"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9952,
    cy: 21.0049,
    r: 20.4328,
    transform: "rotate(-180 20.9952 21.0049)",
    stroke: "inherit",
    strokeWidth: 1.14414
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrow-circle.5c286f8ea52971c7d13fb52c2514bc55.svg";
export { ForwardRef as ReactComponent };